<template>
	<div
		v-drag-scroller.onlyX="options"
		class="flex grow-0 shrink max-w-full overflow-x-auto overflow-y-auto cursor-grab">
		<div
			v-if="title"
			class="flex items-center justify-center my-2 w-10 left-0 bg-mabey-950 rounded sticky z-10 shadow-md">
			<span class="flex font-bold text-lg whitespace-nowrap -rotate-90 text-white">
				{{ title }}
			</span>
		</div>

		<slot></slot>
	</div>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'
	import { dragScroller } from 'vue-drag-scroller'

	withDefaults(
		defineProps<{
			title?: string
		}>(),
		{
			title: undefined
		}
	)

	const vDragScroller = dragScroller

	const options = ref({
		startScroll: (e) => {
			dragging(e)
		},
		endScroll: (e) => {
			stoppedDragging(e)
		},
		speed: 1
	})

	/**
	 * Event: User drags scrollable area
	 * @param e Event
	 */
	function dragging(e: Event) {
		const el = e.target

		if (el instanceof HTMLElement) {
			el.classList.remove('cursor-grab')
			el.classList.add('cursor-grabbing')
		}
	}

	/**
	 * Event: User stops dragging scrollable area
	 * @param e Event
	 */
	function stoppedDragging(e: Event) {
		const el = e.target

		if (el instanceof HTMLElement) {
			el.classList.remove('cursor-grabbing')
			el.classList.add('cursor-grab')
		}
	}
</script>
